import React, { useState, useEffect, useCallback } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const MONTHS_FR = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

export default function DesignerInvoices() {
  const { t } = useLanguage();
  const [invoices, setInvoices] = useState([]);
  const [settings, setSettings] = useState({});

  const fetchData = useCallback(async () => {
    try {
      const [iRes, sRes] = await Promise.all([
        axios.get(`${API}/api/designs/invoices`, { withCredentials: true }),
        axios.get(`${API}/api/designs/settings`, { withCredentials: true })
      ]);
      setInvoices(iRes.data);
      setSettings(sRes.data);
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const rate = settings.rate_vnd || 100000;
  const totalAll = invoices.reduce((acc, inv) => acc + (inv.total_vnd || 0), 0);

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">{t('invoice_recap')}</h1>
            <p className="text-sm text-slate-600 mt-1">{t('invoice_recap_desc')}</p>
          </div>
          <Card className="border-emerald-200 bg-emerald-50 px-4 py-2">
            <p className="text-sm text-emerald-600">Total : <span className="font-bold text-lg">{totalAll.toLocaleString()} VND</span></p>
          </Card>
        </div>

        {invoices.length === 0 ? (
          <p className="text-sm text-slate-500 text-center py-8" data-testid="no-invoices">{t('no_invoices')}</p>
        ) : (
          <Accordion type="multiple" className="w-full space-y-2" data-testid="invoices-accordion">
            {invoices.map(inv => (
              <AccordionItem key={`${inv.year}-${inv.month}`} value={`${inv.year}-${inv.month}`} className="border border-slate-200 rounded-lg overflow-hidden shadow-sm">
                <AccordionTrigger className="hover:no-underline py-4 px-5 bg-white hover:bg-slate-50" data-testid={`invoice-month-${inv.year}-${inv.month}`}>
                  <div className="flex items-center justify-between w-full pr-2">
                    <span className="text-base font-semibold text-slate-800">{MONTHS_FR[inv.month - 1]} {inv.year}</span>
                    <div className="flex items-center gap-4">
                      <span className="text-sm text-slate-500">{inv.count} design(s)</span>
                      <span className="text-lg font-bold text-emerald-700">{(inv.total_vnd || 0).toLocaleString()} VND</span>
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="px-5 pb-4">
                    <div className="divide-y divide-slate-100">
                      {inv.designs.map((d, i) => (
                        <div key={`inv-${inv.year}-${inv.month}-${i}`} className="flex items-center justify-between py-2.5 text-sm">
                          <span className="text-slate-500 w-24">{new Date(d.validated_at).toLocaleDateString('fr-FR')}</span>
                          <span className="flex-1 font-medium">{d.club_name}</span>
                          <span className="text-slate-600">{d.commercial_name}</span>
                          <span className="font-medium text-emerald-700 w-32 text-right">{rate.toLocaleString()} VND</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </div>
    </Layout>
  );
}
